import CellWithTooltip from './CellWithTooltip'
import CheckboxCell from './CheckboxCell'
import ContentLibraryCell from './ContentLibraryCell'
import DisplayNameWithFirmNameCell from './DisplayNameWithFirmNameCell'
import IsActiveCell from './IsActiveCell'
import MultiValueCellWithTooltip from './MultiValueCellWithTooltip'
import ProductNameCell from './ProductNameCell'

const tableCell: Record<string, (prop: any) => JSX.Element> = {
    categories: MultiValueCellWithTooltip,
    hasManufacturerOptions: CheckboxCell,
    canAutoGenerateProductSpecification: CheckboxCell,
    isActive: IsActiveCell,
    displayNameWithFirmName: DisplayNameWithFirmNameCell,
    productName: ProductNameCell,
    partnershipLinksSM: CellWithTooltip,
    partnershipLinksULE: CellWithTooltip,
    partnershipLinksSwatchbox: CellWithTooltip,
    firmLogoUrl: CellWithTooltip,
    contentLibrary: ContentLibraryCell,
}

export default tableCell
